// Welke vragen zijn bij deze respondent inmiddels verborgen?
//
// Voedt het opruimen van weesantwoorden: wijzigt de respondent het antwoord
// waar een vervolgvraag van afhangt, dan verdwijnt die vraag — maar zijn al
// opgeslagen antwoord blijft in QuestionnairesResponses staan en telt mee in
// elke grafiek, export en AI-context.
//
// Sectiekoppen tellen niet mee: die hebben geen antwoord. De VRAGEN van een
// verborgen sectie wel.
//
// AI-CONTEXT: See docs/features/conditional-questions.md

/**
 * @param {Array<object>} fields - Alle velden die op dit meetmoment gesteld
 *   kunnen worden (dus na filterFieldsForMoment, vóór de conditionele filter)
 * @param {Array<object>} visibleFields - Wat er ná de conditionele filter overblijft
 * @returns {Array<string>} `QuestionnaireFields.ID`'s die nu geen antwoord horen te hebben
 */
const hiddenQuestionIDs = (fields, visibleFields) => {
    if (!Array.isArray(fields)) return []

    const visible = new Set((Array.isArray(visibleFields) ? visibleFields : []).map((f) => f?.ID))

    return fields
        .filter((field) => field?.ID && field?.Type !== 'section' && !visible.has(field.ID))
        .map((field) => field.ID)
}

export default hiddenQuestionIDs
